import { STYLE_PROPERTY } from "../constants/variables/css_style";

// the below function will provide the css, compatable for the react.
export function getStyleCss(styles, preStyle = {}) {
  try {
    const tempStyle = preStyle;
    styles.map((ele: { key: string | number; value: any }) => {
      let tempKey = ele.key;
      const tempValue = ele.value;
      if (typeof STYLE_PROPERTY[tempKey] !== "undefined") {
        tempKey = STYLE_PROPERTY[tempKey];
      }

      tempStyle[tempKey] = ele.value;
    });
    return tempStyle;
  } catch (err) {
    console.warn(err);
    return {};
  }
}

export const executeScroll = ({ ref, headerOffset = 75 }) => {
  const element = ref.current;
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
};
